/**
 *  @since 0.0.1
 */
export const overloadsSymb = Symbol();
/**
 *  @since 0.0.1
 */
export const interpretable = (program) => program;
/***
 * Provides Program builder for the given Program type (Exposing a specific Algebra)
 */
/**
 *  @since 0.0.1
 */
export const defineFor = _ => () => a => a;
